@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="row hdrBar">
  <div class="col-lg-8 col-md-8 mg-a">
    @if (clntDtls && clntDtls.length > 0) {
    <h1>Clean Andhra Pradesh(CLAP)</h1>
    }
  </div>
  <div class="col-lg-4 col-md-4 mg-a" style="text-align: right">
    <span>Select Date:</span>
    <nz-date-picker
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)"
    ></nz-date-picker>
  </div>
</div>
<div class="main">
  <div class="row">
    <div
      class="row bg-wp"
      style="padding: 2px 10px 2px 20px; margin: 0px 10px; width: 100%"
    >
      <h1
        class="hdrTxt_sm hdrSdLbls"
        style="text-align: center; text-transform: capitalize"
      >
        GRAMEEN
      </h1>
      <ul class="cards">
        @for (d of tdyCoveredDstnce; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #63badb 0%, #35a1af 100%);
            "
            (click)="cardFive()"
            [ngClass]="crdFive == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Vehicles</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.actve_rural_ttl === null ? "0" : d.actve_rural_ttl }}
                  </h1>
                  <h1 class="card_sub_title">Active</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.inact_rural_ttl === null ? "0" : d.inact_rural_ttl }}
                  </h1>
                  <h1 class="card_sub_title">Spare</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        } @for (d of tdyCoveredDstnce; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #7f75e5 0%, #4e49b9 100%);
            "
            (click)="cardSix()"
            [ngClass]="crdSix == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Operational Status</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_operated === null ? "0" : d.r_operated }}
                  </h1>
                  <h1 class="card_sub_title">Operated</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_opper === null ? "0" : d.r_opper }} %
                  </h1>
                  <h1 class="card_sub_title">Operated %</h1>
                </div>
              </div>
              <div class="row">
                <p class="crdFtr">
                  VEHICLES TRAVELLED > 500 Meters IS CONSIDERED AS OPERATED
                </p>
              </div>
            </div>
          </div>
        </li>
        } @for (d of vhclsTrvld; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #9267d9 0%, #683eb5 100%);
            "
            (click)="cardSeven()"
            [ngClass]="crdSeven == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Vehicles Travelled</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.rrl_tdydst_abv30 === null ? "0" : d.rrl_tdydst_abv30 }}
                  </h1>
                  <h1 class="card_sub_title">>= 30km</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.rrl_tdydst_blw30 === null ? "0" : d.rrl_tdydst_blw30 }}
                  </h1>
                  <h1 class="card_sub_title">< 30km</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        } @for (d of tdyCoveredDstnce; track d) {
        <li class="cards_item">
          <div
            class="card_g"
            style="
              background: linear-gradient(135deg, #63b5f5 0%, #449ee5 100%);
            "
            (click)="cardEight()"
            [ngClass]="crdEight == true ? 'active_class' : 'normalclass'"
          >
            <div class="card_content">
              <div class="row">
                <h1 class="crdHdr">Distance covered</h1>
              </div>
              <div class="row">
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_dst === null ? 0 : d.r_dst }}
                  </h1>
                  <h1 class="card_sub_title">Total Distance</h1>
                </div>
                <div class="col card_prt">
                  <h1 class="crdHdr_sb_sm">
                    {{ d.r_avg_dst === null ? 0 : d.r_avg_dst }}
                  </h1>
                  <h1 class="card_sub_title">Average</h1>
                </div>
              </div>
            </div>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
  @if (crdFive==true) {
  <div class="row bg-wp">
    <h1>District Wise vehicles Status (RURAL)</h1>
    <div id="ruralVehiclesChart"></div>
  </div>
  } @if (crdSix==true) {
  <div class="row bg-wp">
    <h1>District Wise vehicles Operational Status (RURAL)</h1>
    <div id="ruraloperStatusChart"></div>
  </div>
  } @if (crdSeven==true) {
  <div class="row bg-wp">
    <h1>District Wise Travelled Vehicles (RURAL)</h1>
    <div id="ruraltrvlVhcleChart"></div>
  </div>
  }
  <div class="row bg-wp">
    <h1>District Wise Vehicles Summary</h1>
    <div class="ds-card grid tbl">
      <app-data-grid
        [totalItems]="gridTotals0"
        [groupItems]="gridGroups0"
        class="p-8"
        style="width: 100%"
        [dataSource]="dstrctTripsDta"
        [legacyColumns]="ulbTripscolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="District Trips Data"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
        [cellPrepared]="bound_onCellPrepared"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="true"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoUlb(data)">
              <i nz-icon nzType="node-index" nzTheme="outline"></i>
              <p>Quick View</p>
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>

  @if (ShowClap) {
  <div class="row bg-wp">
    <h1>Vendor wise operated vehicles and operated %</h1>
    <div class="ds-card tbl grid">
      <app-data-grid
        class="p-8"
        style="width: 100%"
        [dataSource]="ulbVndrwseopratedTripsTble"
        [legacyColumns]="ulbVndrwseopratedTripsTblecolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="District wise operated Trips"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
      >
      </app-data-grid>
    </div>
  </div>
  }
</div>
